import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context: _ctx }) => {
    // Auth is enforced inside AppShell via useAuth
    // If we had query context we could check here too
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
